import { render } from "./Loan.vue?vue&type=template&id=1a0563fa&scoped=true"
import script from "./Loan.vue?vue&type=script&lang=js"
export * from "./Loan.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a0563fa"

export default script